// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"823":"2079b5bb","884":"ad0e724d"}[chunkId] + ".chunk.js";
};